import {
  type DynamicClient,
  type WalletAccount,
  getOwnerWalletAccountForSmartWalletAccount,
} from '@dynamic-labs-sdk/client';
import { assertDefined } from '@dynamic-labs-sdk/client/core';

import { getZerodevProviderFromSettings } from '../getZerodevProviderFromSettings';

type ShouldUseEIP7702Params = {
  smartWalletAccount: WalletAccount;
};

export const shouldUseEIP7702 = (
  { smartWalletAccount }: ShouldUseEIP7702Params,
  client: DynamicClient
) => {
  const zerodevProvider = getZerodevProviderFromSettings(client);

  assertDefined(
    zerodevProvider,
    'Zerodev provider is not enabled in project settings'
  );

  const eoaWalletAccount = getOwnerWalletAccountForSmartWalletAccount(
    { smartWalletAccount },
    client
  );

  assertDefined(eoaWalletAccount, 'EOA wallet account is not found');

  return (
    zerodevProvider.enableEIP7702 &&
    // with EIP7702, the EOA wallet account address is the same as the smart wallet account address
    smartWalletAccount.address === eoaWalletAccount.address
  );
};
